import { useState } from "react";
import { useDispatch } from "react-redux";

import t from "../../../../i18n/i18n";
import useApi from "../../../../services/api";

import Input from "../../../../components/form/input";
import Notify from "../../../../components/notification/notify";
import { handleApiErrors } from "../../../../utils/handleErrors";

function PasswordForm({ user }) {
  const { ApiAdminUpdateUser } = useApi();

  const [form, setForm] = useState({});

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function submitForm(e) {
    e.preventDefault();

    if (!form.newPassword) return Notify({ type: "danger", message: t("Errors.EmptyNewPassword") });
    if (!form.newPasswordConfirmation)
      return Notify({ type: "danger", message: t("Errors.EmptyNewPasswordConfirmation") });
    if (form.newPasswordConfirmation !== form.newPassword)
      return Notify({ type: "danger", message: t("Errors.InvalidNewPasswordConfirmation") });

    const { data } = await ApiAdminUpdateUser({
      id: user.id,
      password: form.newPassword,
    });

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    setForm({});

    return Notify({ type: "success", message: t("Success.PasswordChanged") });
  }

  return (
    <div className="form-col profile-form ">
      <h1 className="text-uppercase">{t("Profile.PasswordChangeTitle")}</h1>
      <form onSubmit={submitForm}>
        <Input
          label={t("Profile.Form.NewPassword")}
          name="newPassword"
          value={form.newPassword || ""}
          onChange={handleInputChange}
          type="password"
        />
        <Input
          label={t("Profile.Form.NewPasswordConfirmation")}
          name="newPasswordConfirmation"
          value={form.newPasswordConfirmation || ""}
          onChange={handleInputChange}
          type="password"
        />

        <div className="submit-btn no-border">
          <button type="submit" className="btn-regester">
            {t("Profile.Form.Submit")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default PasswordForm;
